import { workdaysBetween } from "../utils/workdays";

// ---------------------------------------------------------------------------
// Wie alt ist ein Lead — EINE Rechnung fuer alle, die sie brauchen.
// ---------------------------------------------------------------------------
// Bis LEAD-1/LEAD-6 (2026-07-30) stand dieselbe Staffel zweimal im Code: als
// Konstanten im Notification-Projektor und als eigene Kopie im
// Lead-Dashboard. Zwei Kopien heisst zwei Wahrheiten, sobald jemand eine
// davon anfasst — und genau das passiert jetzt, weil Prinzip 16 die EINHEIT
// aendert. Also gibt es die Staffel nur noch hier.
//
// Prinzip 16 (Daniel 2026-07-30, «keine Notifications an Wochenenden!!!»):
// gezaehlt werden ARBEITSTAGE. Wer am Freitag zuteilt und am Montag «seit
// 3 Tagen» liest, wird fuer zwei Tage gemahnt, an denen das OS selbst
// geschwiegen hat. Die Zahlen unten sind dieselben wie vorher, die Einheit
// ist neu: kalendarisch dauert jede Stufe damit rund 40 % laenger.

export const LEAD_UNASSIGNED_STALE_WORKDAYS = 3;
export const LEAD_PL_STALE_WORKDAYS = 7;
export const LEAD_CRITICAL_WORKDAYS = 14;

/** Arbeitstage, seit der Lead angelegt wurde. Nie negativ. */
export function leadWorkdaysOpen(createdAt: Date, now: Date): number {
  return workdaysBetween(createdAt, now);
}

export type LeadEscalationLevel =
  | "fresh"
  | "unassigned_stale"
  | "pl_stale"
  | "critical";

/**
 * Eskalationsstufe eines offenen Leads. Exklusiv — `critical` schliesst die
 * beiden anderen aus.
 */
export function leadEscalationLevel(
  workdaysOpen: number,
  ownerUserId: string | null,
): LeadEscalationLevel {
  if (workdaysOpen >= LEAD_CRITICAL_WORKDAYS) return "critical";
  if (ownerUserId === null) {
    return workdaysOpen >= LEAD_UNASSIGNED_STALE_WORKDAYS
      ? "unassigned_stale"
      : "fresh";
  }
  return workdaysOpen >= LEAD_PL_STALE_WORKDAYS ? "pl_stale" : "fresh";
}
